import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { reduxForm, Field, SubmissionError, change } from 'redux-form'
import { validateMessages } from '../../constants/messages'
import InputAuth from '../common/inputAuth';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormFeedback,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Row
} from 'reactstrap';

import { validaLogin } from '../../actions/authActions';
import { nextField } from '../../util/nextField';

const EsqueciPwdForm = ({
    title,
    sendButtonText,
    className,
    bgColorContainer,
    redirectBack,
    handleSubmit,
    onValidated,
    labels,
    hash,
    bgColor,
    textColor,
    redirect,
    boxTitle,
    bgColorBoxTitle,
    textColorBoxTitle,
    Public_IP,
    Private_IP
}) => {
    const [cpf, setCpf] = useState('');
    const [login, setLogin] = useState('');
    const [loginValid, setLoginValid] = useState(true);
    const [cpfValid, setCpfValid] = useState(true);

    const dispatch = useDispatch();
    const { cpfLoginValidated, validatingCpfLogin, errorCode } = useSelector(({ authreducer }) => authreducer );

    useEffect(() => {
        if (!!validatingCpfLogin) return;
        if (!cpfLoginValidated) {
            switch (errorCode) {
                case "HASH_INVALIDO":
                    toastr.error('Link inválido, solicite novamente a recuperação de senha através do "Esqueci minha senha".');
                    break;
                case "HASH_EXPIRADO":
                    toastr.error('Link expirado, solicite novamente a recuperação de senha através do "Esqueci minha senha".');
                    break;
                case "REVOGADO_INATIVO":
                    toastr.error('Usuário não autorizado, entre em contato com Controle de Acessos.');
                    break;
                default:
                    toastr.error('Dados inválidos, confirme os dados digitados. Caso esteja correto entre em contato com Controle de Acessos');
                    break;
            }
            return;
        }

        const payload = {
            cpf: cpf.replace(/[^a-zA-Z0-9]/g, ''),
            login,
            ip: {
                Private_IP,
                Public_IP
            }
        };

        !!onValidated && onValidated(payload);
    }, [cpfLoginValidated, validatingCpfLogin]);

    useEffect(() => {
       if(login) {
           setLoginValid(true);
       }

       if(cpf) {
            setCpfValid(true);
            dispatch(change('frmEsqueciPdw', 'cpf', cpf));
        }

    },[cpf, login])

    const onSend = async () => {
        let errors = {};

        if(!login || !cpf) {
            if(!login){
                setLoginValid(false);
                errors.login = validateMessages.campoObrigatorio;
                toastr.error('Atenção', validateMessages.usuarioField);
            }
            if(!cpf){
                setCpfValid(false)
                errors.cpf = validateMessages.campoObrigatorio;
                toastr.error('Atenção', validateMessages.cpfCnpjField);
            }

            if(Object.keys(errors).length > 0) {
                throw new SubmissionError(errors)
            }

            return;
        }

        const payload = {
            cpf: cpf.replace(/[^a-zA-Z0-9]/g, ''),
            login,
            hash,
            ip: {
                Private_IP,
                Public_IP
            }
        };

        dispatch(validaLogin(payload))

    };

    const maskCPFandCNPJ = (texto) => {
        texto= texto.replace(/(\.|\/|\-)/g,"");
            if (texto.length <= 11) {
                setCpf(texto.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,"\$1.\$2.\$3\-\$4"));
            } else {
                setCpf(texto.replace(/([a-zA-Z0-9]{2})([a-zA-Z0-9]{3})([a-zA-Z0-9]{3})([a-zA-Z0-9]{4})([0-9]{2})/g,
            '$1.$2.$3/$4-$5'));
            }
    }

    const onBack = () => {
        document.location.href = redirect || '#/';
    };

    return (
        <React.Fragment>
            <div className="app flex-row align-items-center animated fadeIn">
                <Container>
                    <Form id="frmEsqueciPdw" name="frmEsqueciPdw" className="mp-0 w-100" onSubmit={ handleSubmit(v => onSend(v))}>
                        <Row className="justify-content-center">
                            <Col md="6">
                                <Card className="mx-4" style={{ backgroundColor: bgColorContainer || '', color: textColor}}>
                                {boxTitle && <Card md="8" style={{
                                        backgroundColor: bgColorBoxTitle,
                                        borderRadius: '0.25rem 0.25rem 0 0',
                                        borderStyle: 'none',
                                        margin: '0',
                                        padding: '12px 0 0 24px',
                                }}>
                                    <h1 style={{color: textColorBoxTitle, fontSize: '25px'}}>{boxTitle}</h1>
                                </Card>}
                                    <CardBody className="p-4" style={{color: textColor}}>
                                        <h1 style={{color: textColor}}>{title}</h1>
                                        <p className="text-muted" style={{color: textColor}}>{labels.login}</p>

                                        <InputGroup className="mb-3">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="icon-user"></i>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Field component={InputAuth} type="input" name="login"
                                                        onChange={(e) => setLogin(e.target.value)}
                                                        placeholder="Digite seu usuário" icon='user' autocomplete="login" />
                                                </InputGroup>

                                                <InputGroup className="mb-3">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="icon-user"></i>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Field
                                                        component={InputAuth}
                                                        type="input" name="cpf"
                                                        placeholder="000.000.000-00"
                                                        onChange={(e) => maskCPFandCNPJ(e.target.value)}
                                                        autocomplete="cpf"
                                                        maxLength={18}
                                                    />
                                                </InputGroup>


                                        <Button
                                            className="text-white"
                                            color="primary-smart"
                                            id="esqueciSenhaEnviar"
                                            block
                                        >{sendButtonText}</Button>
                                        <Button
                                            color="secundary-smart"
                                            id='esqueciSenhaVoltar'
                                            block
                                            onClick={onBack}
                                        >Voltar</Button>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default reduxForm({
    form: 'frmEsqueciPdw'
  })(EsqueciPwdForm);
